import React from 'react'
import { Link } from 'react-router-dom'
import FeedList, { SkeletonCards } from '../Components/FeedList'
import { ChatIcon } from '../Components/Icons'
import { useRail } from '../Components/Layout'
import { useDocumentTitle } from '../Hooks/useDocumentTitle'
import { useFeed } from '../Hooks/useFeed'
import { t } from '../i18n'
import { api } from '../Services/api'
import { useDiscussions } from '../State/Discussions'
import { useFollow } from '../State/Follow'

/* Diskusije: the stories readers comment on most this week,
   each with its newest comment and where it was written. One thread per
   story, whichever portal's article a comment was posted under. */
export default function Discussions() {
  const { enabled, loaded } = useDiscussions()
  const { sources: followed } = useFollow()
  const feed = useFeed(
    `discussions:${followed.join(',')}`,
    (page) => api.discussions({ ...page, followed }),
    { enabled }
  )
  useDocumentTitle(t('discussions.title'))
  useRail({ discussions: false }) // the rail's "Najviše komentara" is this page

  if (!enabled) {
    return loaded ? (
      <div className="feed-message">
        <p>{t('discussions.off')}</p>
        <Link to="/" className="btn btn-secondary">
          {t('notFound.home')}
        </Link>
      </div>
    ) : (
      <SkeletonCards count={4} />
    )
  }

  return (
    <div className="discussions">
      <header className="discussions-head">
        <h1 className="discussions-title">
          {t('discussions.title')}
          <span className="badge-experiment">{t('discussions.experiment')}</span>
        </h1>
        <p className="muted">{t('discussions.intro')}</p>
      </header>
      <FeedList
        feed={feed}
        ads={false}
        from="discussions"
        empty={
          <>
            <ChatIcon size={28} className="muted-icon" />
            <p>{t('discussions.empty')}</p>
            <Link to="/" className="btn btn-secondary">
              {t('discussions.emptyCta')}
            </Link>
          </>
        }
      />
    </div>
  )
}
